<div class="super-navigation">
  <div class="container-fluid super-navigation__container">
    <a
      routerLink="/products/quickconnect-app-solutions/smartphone-app-accesibility-design"
      class="super-navigation__link">

      VPAT 508
    </a>
    <a
      routerLink="/our-partners"
      class="super-navigation__link">

      Our Partners
    </a>
    <a
      routerLink="/quickseries-gsa-schedule"
      class="super-navigation__link">

      GSA Info
    </a>
    <a
      routerLink="/contact-us"
      class="super-navigation__link">

      Contact Us
    </a>
  </div>
</div>

<div class="main-navigation">
  <div class="container-fluid main-navigation__main-nav">
    <button
      type="button"
      class="main-navigation__menu qs-icon qs-icon--hamburger qs-icon--medium"
      (click)="toggleNavigation(navIsOpen$())">

      Menu
    </button>

    <a
      class="main-navigation__logo"
      [routerLink]="['/']"
      (click)="toggleNavigation(navIsOpen$())">

      <img
        src="https://qs-website-dev2.s3.us-east-2.amazonaws.com/QS_Logo_Red_e287b3fd32.svg"
        alt="Logo for QuickSeries Publishing - Reliable Content. Innovative Delivery"
        loading="eager"
        width="70"
        height="40"
        loading="lazy">
    </a>

    <nav
      class="main-navigation__links"
      [ngClass]="{
        'main-navigation__links--is-open': navIsOpen$()
      }">

      <div class="main-navigation__mobile-header">
        <a
          [routerLink]="['/']"
          class="main-navigation__logo main-navigation__logo--mobile">

          <img
            src="https://qs-website-dev2.s3.us-east-2.amazonaws.com/QS_Logo_Red_e287b3fd32.svg"
            alt="Logo for QuickSeries Publishing - Reliable Content. Innovative Delivery"
            loading="eager"
            width="70"
            height="40"
            loading="lazy">
        </a>

        <button
          type="button"
          class="main-navigation__close qs-icon qs-icon--close"
          (click)="toggleNavigation(navIsOpen$())">

          Close
        </button>
      </div>

      @if (mainNavLinks$()) {
        @for (nav of mainNavLinks$()!.data; track nav) {
          <button
            type="button"
            class="main-navigation__link main-navigation__link--with-sub-menu"
            aria-haspopup="true"
            [attr.aria-expanded]="subMenuState$() === nav.attributes.sub_menu"
            [class.main-navigation__link--active]="isCurrentPath(nav.attributes.ctas[0].routerLink!)"
            (click)="toggleSubNav(nav.attributes.sub_menu)">

            {{ nav.attributes.label }}
          </button>
        }
      }

      <a
        class="main-navigation__link"
        [routerLink]="['/', 'about-quickseries']"
        [routerLinkActive]="'main-navigation__link--active'"
        (click)="toggleNavigation(navIsOpen$())">

        About Us
      </a>

      <button
        type="button"
        class="main-navigation__link main-navigation__link--search-btn qs-icon qs-icon--search qs-icon--small"
        aria-haspopup="true"
        (click)="openSearchModal()">

        Search
      </button>

      <app-search-input
        class="main-navigation__link main-navigation__link--search-input"
        aria-haspopup="true">
      </app-search-input>
    </nav>
  </div>
</div>

<div class="main-navigation__sub-menus">

  @if (mainNavLinks$()?.data) {
    @for (nav of mainNavLinks$()!.data; track nav) {
      @if (subMenuState$() === nav.attributes.sub_menu) {
        <app-sub-menu
          [title$]="nav.attributes.label"
          [links$]="nav.attributes.ctas"
          [type$]="nav.attributes.sub_menu"
          [description$]="nav.attributes.description">

          @switch (nav.attributes.sub_menu) {
            @case (ESubMenuType.CONTENT) {
              <app-sub-menu-content />
            }
            @case (ESubMenuType.PRINT_SOLUTIONS) {
              <app-sub-menu-print-solutions />
            }
            @case (ESubMenuType.QUICK_CONNECT_APP_SOLUTIONS) {
              <app-sub-menu-app-solutions />
            }
            @case (ESubMenuType.WHITEBOARD_VIDEOS) {
              <app-sub-menu-whiteboard-video />
            }
            @case (ESubMenuType.QUICK_BLOG) {
              <app-sub-menu-quickblog />
            }
          }
        </app-sub-menu>
      }
    }
  }
</div>
